module.exports = __webpack_public_path__ + "static/media/tan-s-10.8da2df8f.png";